/* eslint-disable no-constant-condition */
/* eslint-disable react-hooks/exhaustive-deps */
import { Formik, Form } from "formik";
import CreditProgress from "~components/CreditProgress/index";
import ContainerForm from "~components/Form/components/ContainerForm";
import useCredit from "../hooks/useCredit";
import { useEffect, useMemo, useRef, useState } from "react";
import CurrencyInput from "~components/Form/components/CurrencyInput";
import { IconDOC, IconDefault, IconJPG, IconPDF, IconPNG, IconSuccess, InfoFormDefault, InfoUpload, WarningIcon2 } from "~misc/icons";
import { Input } from "@chakra-ui/react";
import useTransportValue from "../hooks/useTransportValue";
import { GetIndexBD } from "~services/utils/GetIndexBD";
import { useGetCreditosCliente, useSalvarLimiteCredito } from "~pages/Wallet/hooks/useWallet";
import { money } from "~hooks/useHelpers";
import Loader from "~components/Form/components/Loader";
import { initialPath } from "~misc/paths";
import ValidateFormModal from "~components/Modal/ValidateFormModal";
import useTrilha from "~/fetchs/useTrilha";
import originControl from "~services/utils/originControl";
import { useNavigate, useSearchParams } from "react-router-dom";
import ModalAction from "~components/Modal/ModalAction";
import useParametros from "~/fetchs/useParametros";
import { getLocalStorage, saveLocalStorage } from "~services/utils/SaveIndexBD";
import { db } from "~/db/db";
import useOnlineStatus from "~hooks/useOnlineStatus";
import { setCustomLocalStorage } from "../utils/creditHelpers";
import MessageForm from "~components/Form/components/MessageForm";
import appInsights from "~/appInsights";
import useUsuario from "~/fetchs/useUsuario";
import { updateConvertedClient } from '../../helpers/updateConvertedClient';

const TELEMETRY_SOURCE = "CARTEIRA_LIMITE_CREDITO";

const getCodigoCliente = (emissor, recebedor) => {
  const data = emissor?.id ? emissor : recebedor;
  return data?.codigoCliente ?? data?.codigo ?? data?.clienteCodigo ?? data?.id ?? null;
};

const getCodigoUsuario = (usuario) => {
  return usuario?.codigo ?? usuario?.codigoUsuario ?? usuario?.usuarioCodigo ?? usuario?.id ?? null;
};

const Credit = ({ id = 0, limite = 200000, limiteMaximo = 5000000, tempoSolicitacaoDocumento = 30, tamanhoMaximoUploadMB = 30, setBackRoute, setRecebedorEmissor, cliente }) => {
  const isOnline = useOnlineStatus();
  const { usuario } = useUsuario();


  const [emissorData, setEmissorData] = useState({});
  const [recebedorData, setRecebedorData] = useState({});
  const [limiteData, setLimiteData] = useState({});
  const { trilhas } = useTrilha();
  const [trilhaCliente, setTrilhaCliente] = useState(null);
  const [creditos, setCreditos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [atualVC, setAtualVC] = useState(0);
  const [atualPagueFlex, setAtualPagueFlex] = useState(0);
  const [atualVloz, setAtualVloz] = useState(0);
  const [tempoUltimoUploadEmDias, setTempoUltimoUploadEmDias] = useState(0);
  const [tamanhoMaximoUpload, setTamanhoMaximoUpload] = useState(tamanhoMaximoUploadMB);

  const [documentos, setDocumentos] = useState([]);

  const [limiteParametro, setLimiteParametro] = useState(limite);
  const [limiteParametroFlex, setLimiteParametroFlex] = useState(limite);

  const [incrementoParametro, setIncrementoParametro] = useState(20000);
  const [limiteMaximoParametro, setLimiteMaximoParametro] = useState(5000000);
  const [tempoRequisitarDocumentacaoParametro, setTempoRequisitarDocumentacaoParametro] = useState(tempoSolicitacaoDocumento);

  const [showMessageForm, setShowMessageForm] = useState({
    text: "",
    type: "success",
    icon: IconSuccess,
  });

  const formikRef = useRef();

  const navigate = useNavigate();

  const { getOrigem, origens, persistentParameters } = originControl();
  const [searchParams] = useSearchParams();
  const origem = searchParams.get("origem");
  const origemCadastroRecebedor = origem === origens.cadastro_recebedor;
  const origemCadastroEmissor = origem === origens.cadastro_emissor;

  const tipoCarteira = origemCadastroEmissor ? "emissor" : "recebedor";
  const cadastro = origemCadastroEmissor ? emissorData : recebedorData;
  const trilhaNome = (cadastro?.trilha?.nome
    ?? trilhas.find((item) => String(item.id) === String(cadastro?.trilhaId))?.nome)?.toUpperCase();
  const acessoJornadaFunil = (origemCadastroEmissor || origemCadastroRecebedor)
    && ["IMO", "INFRA"].includes(trilhaNome)
    && usuario?.slugAcessos?.includes('acesso-ao-menu-de-funil-de-obras');
    
  const pp = searchParams.get("pp") || "";
  const prospectOrigem = pp.split(',').includes(origens.conversao_prospect)
    ? Number(searchParams.get("prospect-origem") || (emissorData?.conversao ? emissorData.id : 0)) : 0;

  const onSuccess = async (data) => {
    (async () => {
      if (data?.data?.ultimosUploads?.length) {
        await db.ultimosUploadsDocumentos.bulkPut(data.data.ultimosUploads);
      }
    })();

    try {
      const clienteId = recebedorData?.id ?? emissorData?.id ?? id ?? null;
      appInsights.trackTrace({
        message: `[${TELEMETRY_SOURCE}] LimiteCreditoSalvoSucesso ClienteId=${clienteId}`,
        severityLevel: 1,
        properties: {
          traceSource: TELEMETRY_SOURCE,
          traceEvent: "LIMITE_CREDITO_SUCESSO",
          traceSearch: `cliente:${clienteId}|codigoCliente:${getCodigoCliente(emissorData, recebedorData) ?? "NA"}|usuario:${getCodigoUsuario(usuario) ?? "NA"}`,
          clienteId,
          codigoCliente: getCodigoCliente(emissorData, recebedorData),
          codigoUsuario: getCodigoUsuario(usuario),
          dataEnvio: new Date().toISOString(),
        },
      });
    } catch (telemetryError) {
      console.error("Erro ao registrar trace no AppInsights", telemetryError);
    }

    setLoading(false);

    const clienteCadastro = origemCadastroEmissor
      ? data?.data?.clienteEmissor
        ?? (Object.keys(recebedorData ?? {}).length === 0 ? data?.data?.clienteRecebedor : null)
      : data?.data?.clienteRecebedor;
    const clienteId = clienteCadastro?.id;

    if (isOnline && origemCadastroRecebedor
      && pp.split(',').includes(origens.conversao_prospect) && prospectOrigem > 0 && clienteId) {
      await updateConvertedClient(prospectOrigem, clienteId);
    }

    if (acessoJornadaFunil && clienteId) {
      const parametros = new URLSearchParams({ origem: origens.solicitar_credito, "limite-credito": "sucesso", pp });
      if (prospectOrigem > 0) parametros.set("prospect-origem", prospectOrigem);
      
      navigate(`${initialPath}/carteira/${tipoCarteira}/${clienteId}?${parametros}`);
      return;
    }

    navigate(`${initialPath}/carteira/solicitacoes`);
  };

  const onError = (error) => {
    try {
      const clienteId = recebedorData?.id ?? emissorData?.id ?? id ?? null;
      appInsights.trackTrace({
        message: `[${TELEMETRY_SOURCE}] LimiteCreditoSalvoErro ClienteId=${clienteId}`,
        severityLevel: 3,
        properties: {
          traceSource: TELEMETRY_SOURCE,
          traceEvent: "LIMITE_CREDITO_ERRO",
          clienteId,
          codigoCliente: getCodigoCliente(emissorData, recebedorData),
          codigoUsuario: getCodigoUsuario(usuario),
          erroMensagem: error?.message ?? "Erro desconhecido ao salvar limite",
          erroStack: error?.stack ?? null,
          dataEnvio: new Date().toISOString(),
        },
      });
      appInsights.trackException({
        exception: error instanceof Error ? error : new Error(String(error ?? "Erro ao salvar limite")),
        severityLevel: 3,
        properties: {
          traceSource: TELEMETRY_SOURCE,
          traceEvent: "LIMITE_CREDITO_ERRO",
          clienteId,
          codigoCliente: getCodigoCliente(emissorData, recebedorData),
          codigoUsuario: getCodigoUsuario(usuario),
        },
      });
    } catch (telemetryError) {
      console.error("Erro ao registrar trace no AppInsights", telemetryError);
    }

    setLoading(false);
  };

  const limiteSalvar = useSalvarLimiteCredito(
    id == 0
      ? limiteData
      :  {
        limitePagueFlex: Math.round(limiteData.limitePagueFlex) == Math.round(atualPagueFlex) ? 0 : limiteData.limitePagueFlex,
        limiteVC: Math.round(limiteData.limiteVC) == Math.round(atualVC) ? 0 : limiteData.limiteVC,
        limiteVloz: Math.round(limiteData.limiteVloz) == Math.round(atualVloz) ? 0 : limiteData.limiteVloz,
        atualVC,
        atualPagueFlex,
        atualVloz,
        documentos: documentos,
        clienteRecebedor: {
          id,
          trilhaId: cliente?.trilhaId ?? recebedorData?.trilhaId ?? null,
          grupoSegmentoId: cliente?.grupoSegmentoId ?? recebedorData?.grupoSegmentoId ?? null,
          segmentoId: cliente?.segmentoId ?? recebedorData?.segmentoId ?? null,
        },
      },
    onSuccess,
    onError
  );


  async function checkOrigem() {
    const origem = getOrigem();

    CheckEmissor(origem);
    CheckRecebedor(origem);
  }

  async function CheckEmissor(origem = "") {
    const values = await GetIndexBD("form-new-emissor");
    if (values) {
      if (origem == origens.cadastro_emissor) {
        await saveLocalStorage("retornar-dados-emissor", values, true);
        setBackRoute(
          `${initialPath}/carteira/emissor/novo?origem=${origens.solicitar_credito}&pp=${searchParams.get("pp") || ""}`
        );
      }

      setEmissorData(values);
    }
  }

  async function CheckRecebedor(origem = "") {
    const values = await GetIndexBD("form-new-recebedor");
    if (values) {
      if (origem == origens.cadastro_recebedor) {
        await saveLocalStorage("retornar-dados-recebedor", values, true);
        setBackRoute(
          `${initialPath}/carteira/recebedor/novo?origem=${origens.solicitar_credito}&pp=${searchParams.get("pp") || ""}`
        );
        setRecebedorData(values);
      }
    }
  }

  async function CheckCarteira() {
    const data = await GetIndexBD("carteira");
    if (data) {
      let filtered = null;
      for (const item of data) {
        if (item.id == id) {
          filtered = item;
          if ([1, 2].includes(filtered?.tipo)) {
            setRecebedorEmissor(true);
          }
          setRecebedorData(filtered);
          setEmissorData(filtered);
          break;
        }
      }
    }
  }

async function UpdateCarteiraCredito(creditos) {
    const data = await GetIndexBD("carteira");
    if (data) {
        for (const item of data) {
            if (item.id == id) {
                item.creditos = creditos;
                break;
            }
        }
    }
}

  useEffect(() => {
    if (id == 0) {
      checkOrigem();
    } else {
      (async () => {
        await db.ultimosUploadsDocumentos.where('id').equals(Number.parseInt(id)).first().then(e => {
          if (e?.createdAt) {
            const data = e?.createdAt ?? null;
            const dateObject = new Date(data);

            const currentDate = new Date();

            const diffInMilliseconds = currentDate - dateObject;

            const diffInDays = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));

            if (typeof diffInDays == "number") {
              setTempoUltimoUploadEmDias(diffInDays);
            }
          }
        })
      })()
      CheckCarteira();
      setEnableCreditosRequest(true);
    }
  }, []);

  const handleSalvarOffline = async (id) => {
    await setCustomLocalStorage({ key: id });
    limiteSalvar();
  };

  useEffect(() => {
    if (Object.keys(limiteData).length > 0) {
      setLoading(true);

      if (isOnline) {
        limiteSalvar();
        localStorage.removeItem("limite-credito-offline");
      } else {
        const obj = getLocalStorage("limite-credito-offline", true);

        if (!obj) {
          handleSalvarOffline(id);
        } else if (obj[id]) {
          setShowMessageForm({
            text: `Já houve uma alteração de limite requisitada para este cliente no modo offline`,
            icon: WarningIcon2,
            type: "error",
          });
          setLoading(false);
        } else {
          handleSalvarOffline(id);
        }
      }
    }
  }, [limiteData]);

  const { getValidationSchema, initialValues, validateFile, allowedExtensions, validateLimits } = useCredit({
    limite: limiteParametro,
    atualVC: atualVC,
    atualPagueFlex: atualPagueFlex,
    atualVloz: atualVloz,
    limiteF: limiteParametroFlex,
    tamanhoMaximoUpload
  });
  const [validationErrorsDoc, setValidationErrorsDoc] = useState("");


  const {inputVC, inputPagueFlex, inputVloz } =
    useTransportValue();

  const [utilizadoVC, setUtilizadoVC] = useState(0);
  const [disponivelVC, setDisponivelVC] = useState(0);
  const [totalVC, setTotalVC] = useState(0);
  const [totalVcPure, setTotalVcPure] = useState(0);
  const [totalPagueFlexPure, setTotalPagueFlexPure] = useState(0);
  const [limiteAdicionalVC, setLimiteAdicionalVC] = useState(0);

  const [utilizadoPagueFlex, setUtilizadoPagueFlex] = useState(0);
  const [disponivelPagueFlex, setDisponivelPagueFlex] = useState(0);
  const [totalPagueFlex, setTotalPagueFlex] = useState(0);
  const [limiteAdicionalFlex, setLimiteAdicionalFlex] = useState(0);

  const [utilizadoVloz, setUtilizadoVloz] = useState(0);
  const [disponivelVloz, setDisponivelVloz] = useState(0);
  const [totalVloz, setTotalVloz] = useState(0);
  const [limiteAdicionalVloz, setLimiteAdicionalVloz] = useState(0);

  const [solicitadoVC, setSolicitadoVC] = useState(0);
  const [solicitadoPagueFlex, setSolicitadoPagueFlex] = useState(0);
  const [solicitadoVloz, setSolicitadoVloz] = useState(0);

  useEffect(() => {
    if (trilhas?.length && (emissorData?.trilhaId || recebedorData?.trilhaId)) {
      const trilhaIdCliente = emissorData?.trilhaId ? emissorData?.trilhaId : recebedorData?.trilhaId;

      if (trilhaIdCliente) {
        const clienteTrilha = (trilhas || []).find((item) => item.id === trilhaIdCliente);
        setTrilhaCliente(clienteTrilha);
      }
    }
  }, [emissorData, recebedorData, trilhas]);

  useEffect(() => {
    if (totalVC > utilizadoVC + disponivelVC) {
      setTotalVcPure(totalVC);
    }

    if (totalVC === utilizadoVC + disponivelVC) {
      setSolicitadoVC("");
    } else {
      setSolicitadoVC(totalVC);
    }
  }, [totalVC]);


  useEffect(() => {
    formikRef.current.setFieldValue("limiteVotorantim", totalVcPure * 100);
    setTimeout(() => formikRef.current.setFieldTouched("limiteVotorantim", true));
  }, [totalVcPure]);

useEffect(() => {
  if (totalPagueFlex === utilizadoPagueFlex + disponivelPagueFlex) {
    setSolicitadoPagueFlex("");
  } else {
    setSolicitadoPagueFlex(totalPagueFlex);
  }
}, [totalPagueFlex]);


  useEffect(() => {
    formikRef.current.setFieldValue("limiteFlex", totalPagueFlexPure * 100);
    setTimeout(() => formikRef.current.setFieldTouched("limiteFlex", true));

  }, [totalPagueFlexPure]);

  useEffect(() => {

    if (totalVloz > utilizadoVloz + disponivelVloz) setSolicitadoVloz(totalVloz);
    else setSolicitadoVloz("");
  }, [totalVloz]);

  useEffect(() => {
    formikRef.current.setFieldValue("limiteVloz", solicitadoVloz * 100);
    setTimeout(() => formikRef.current.setFieldTouched("limiteVloz", true));
  }, [solicitadoVloz]);

  useEffect(() => {
    if (disponivelVC == 0 && utilizadoVC == 0) {
      setTotalVC(inputVC);
    }
  }, [inputVC]);

  useEffect(() => {
    if (totalPagueFlex > utilizadoPagueFlex + disponivelPagueFlex) setTotalPagueFlexPure(totalPagueFlex);
    if (disponivelPagueFlex == 0 && utilizadoPagueFlex == 0) {
      setTotalPagueFlex(inputPagueFlex);
    }
  }, [inputPagueFlex]);


  const [enableCreditosRequest, setEnableCreditosRequest] = useState(false);
  const creditosRequest = useGetCreditosCliente(id, enableCreditosRequest);
  const { toObjectSlug, getSlug, parameterSlugs, getBySlug } = useParametros();

  useEffect(() => {
    if (creditosRequest.data) {
      UpdateCarteiraCredito(creditosRequest.data);
      setCreditos(creditosRequest.data);
    }
  }, [creditosRequest.data]);

  useEffect(() => {
    setLoading(true);

    if (creditos.length) {
      for (const e of creditos) {
        const item = {
          ...e,
          creditoUtilizado: Number.parseFloat(Number.parseFloat(e.creditoUtilizado).toFixed(2)),
          creditoDisponivel: Number.parseFloat(Number.parseFloat(e.creditoDisponivel).toFixed(2)),
          totalCredito: Number.parseFloat(Number.parseFloat(e.totalCredito).toFixed(2)),
          limiteAdicional: e.limiteAdicional
            ? Number.parseFloat(Number.parseFloat(e.limiteAdicional).toFixed(2))
            : 0
        };

        switch (item.linhaCredito.codigo) {
          case "4007":
            setUtilizadoPagueFlex(item.creditoUtilizado);
            setDisponivelPagueFlex(item.totalCredito + item.limiteAdicional - item.creditoUtilizado);
            setTotalPagueFlex(item.totalCredito);
            setAtualPagueFlex(item.totalCredito);
            setLimiteAdicionalFlex(item.limiteAdicional);
            break;

          case "4000":
            setUtilizadoVC(item.creditoUtilizado);
            setDisponivelVC(item.totalCredito + item.limiteAdicional - item.creditoUtilizado);
            setTotalVC(item.totalCredito);
            setAtualVC(item.totalCredito);
            setLimiteAdicionalVC(item.limiteAdicional);
            break;

          case "4014":
          case "4008":
            setUtilizadoVloz(item.creditoUtilizado);
            setDisponivelVloz(item.totalCredito + item.limiteAdicional - item.creditoUtilizado);
            setTotalVloz(item.totalCredito);
            setAtualVloz(item.totalCredito);
            setLimiteAdicionalVloz(item.limiteAdicional);
            break;
        }
      }



    }

    setLoading(false);
  }, [creditos]);

  useEffect(() => {
    if (toObjectSlug) {
      setLimiteParametro(getSlug(parameterSlugs.credito.valorMinimoUpload, limiteParametro));
      setLimiteParametroFlex(getSlug(parameterSlugs.credito.valorMinimoFlexUpload, limiteParametroFlex));
      setIncrementoParametro(getSlug(parameterSlugs.credito.quantidadeIncremento, incrementoParametro));
      setLimiteMaximoParametro(getSlug(parameterSlugs.credito.valorMaximoSolicitacao, limiteMaximo));
      setTempoRequisitarDocumentacaoParametro(getSlug(parameterSlugs.credito.tempoSolicitarDocumentacao, tempoSolicitacaoDocumento));
      setTamanhoMaximoUpload(getSlug(parameterSlugs.credito.tamanhoMaximoUploadMB, tamanhoMaximoUploadMB));
    }
  }, [toObjectSlug]);

  const uploadDocAvailable = useMemo(() => {
    return !tempoUltimoUploadEmDias || (typeof tempoUltimoUploadEmDias == "number" && tempoUltimoUploadEmDias >= tempoRequisitarDocumentacaoParametro);
  }, [tempoUltimoUploadEmDias, tempoRequisitarDocumentacaoParametro])

const getIconsType = (fileType) => {
  switch (fileType) {
    case "image/png":
      return <IconPNG />;

    case "application/pdf":
      return <IconPDF />;

    case "image/jpeg":
    case "image/jpg":
      return <IconJPG />;

    case "vnd.openxmlformats-officedocument.wordprocessingml.document":
    case "msword":
      return <IconDOC />;

    default:
      return <IconDefault />;
  }
};


  const deleteFile = (index) => {
    console.log(index, 'index to delete');
    const novosDocumentos = documentos.filter((_, i) => i !== index);
    setDocumentos(novosDocumentos);
    formikRef.current.setFieldValue("documentos", novosDocumentos);
  };


  const [openValidateModal, setOpenValidateModal] = useState(false);

  const validateLimitsModal = (values) => {
    const valid = validateLimits(values.limiteVotorantim, values.limiteFlex, values.limiteVloz);

    if (!valid) setOpenValidateModal(true);

    return valid;
  };

  const handleSubmit = (values) => {
    setOpenValidateModal(false);

    if (
      values.limiteVotorantim / 100 < limiteParametro &&
      values.limiteFlex / 100 < limiteParametro &&
      values.limiteVloz / 100 < limiteParametro
    ) {
      values.documentos = null;
    }
    setLimiteData({
      clienteEmissor: emissorData,
      clienteRecebedor: recebedorData,
      limiteVC: values.limiteVotorantim / 100,
      atualVC: utilizadoVC + disponivelVC,
      limitePagueFlex: values.limiteFlex / 100,
      atualPagueFlex: utilizadoPagueFlex + disponivelPagueFlex,
      limiteVloz: values.limiteVloz / 100,
      atualVloz: utilizadoVloz + disponivelVloz,
      documentos: documentos,
    });

    try {
      const codigoCliente = getCodigoCliente(emissorData, recebedorData);
      const codigoUsuario = getCodigoUsuario(usuario);
      const trilhaNome = trilhaCliente?.nome?.toUpperCase() ?? cliente?.trilha?.nome?.toUpperCase() ?? "SEM_TRILHA";
      const clienteId = recebedorData?.id ?? emissorData?.id ?? id ?? null;

      appInsights.trackTrace({
        message: `[${TELEMETRY_SOURCE}] SolicitarLimiteCredito ClienteId=${clienteId}`,
        severityLevel: 1,
        properties: {
          traceSource: TELEMETRY_SOURCE,
          traceEvent: "SOLICITAR_LIMITE_CREDITO",
          traceSearch: `cliente:${clienteId}|codigoCliente:${codigoCliente ?? "NA"}|usuario:${codigoUsuario ?? "NA"}|trilha:${trilhaNome}`,
          clienteId,
          codigoCliente,
          codigoUsuario,
          trilha: trilhaNome,
          isEdicao: String(id != 0),
          modoOffline: String(!isOnline),
          limiteVC: values.limiteVotorantim / 100,
          limiteFlex: values.limiteFlex / 100,
          limiteVloz: values.limiteVloz / 100,
          atualVC: utilizadoVC + disponivelVC,
          atualPagueFlex: utilizadoPagueFlex + disponivelPagueFlex,
          atualVloz: utilizadoVloz + disponivelVloz,
          qtdDocumentos: documentos?.length ?? 0,
          dataEnvio: new Date().toISOString(),
        },
      });
    } catch (telemetryError) {
      console.error("Erro ao registrar trace no AppInsights", telemetryError);
      appInsights.trackException({
        exception: telemetryError,
        severityLevel: 3,
        properties: {
          traceSource: TELEMETRY_SOURCE,
          traceEvent: "SOLICITAR_LIMITE_CREDITO_TRACE_ERROR",
          clienteId: recebedorData?.id ?? emissorData?.id ?? id ?? null,
        },
      });
    }
  };

  const [limiteCreditoPF, setLimiteCreditoPF] = useState(0);
  const [limiteCreditoCPP, setLimiteCreditoCPP] = useState(0);


  useEffect(() => {
    getBySlug("limite-credito-pf").then((parametro) => {
      if (parametro?.valor) setLimiteCreditoPF(Number.parseFloat(parametro?.valor));
    });
  }, []);

  useEffect(() => {
    getBySlug("limite-credito-cpp").then((parametro) => {
      if (parametro?.valor) setLimiteCreditoCPP(Number.parseFloat(parametro?.valor));
    });
  }, []);


  return (
    <Formik
      innerRef={formikRef}
      initialValues={initialValues}
      validationSchema={getValidationSchema({
      limitePF: limiteCreditoPF,
      limiteCPP: limiteCreditoCPP,
      cliente: cliente
    })}
      onSubmit={async (values) => {
        setValidationErrorsDoc("");
        const valid = validateLimitsModal(values);
        if (!valid) return;
        handleSubmit(values);
      }}

    >
      {({ errors, touched, setFieldValue, setFieldTouched, values, isSubmitting }) => (
        <Form className="mt-[-4rem] relative" id="recebedor">
          <div className={loading ? "relative spinner__form-active" : "relative"}>
            {(utilizadoVC > 0 ||
              disponivelVC > 0 ||
              utilizadoPagueFlex > 0 ||
              disponivelPagueFlex > 0 ||
              utilizadoVloz > 0 ||
              disponivelVloz > 0) && (
                <ContainerForm title="Valores Atuais">
                  {(utilizadoVC > 0 || disponivelVC > 0) && (
                    <>
                      <CreditProgress
                        title="Limite Votorantim"
                        buttons={true}
                        bottom={true}
                        barra={true}
                        valuePure={setTotalVcPure}
                        utilizado={utilizadoVC}
                        disponivel={disponivelVC}
                        total={totalVC}
                        setTotal={setTotalVC}
                        buff={incrementoParametro}
                        input={inputVC}
                        limiteMaximo={limiteMaximoParametro}
                        limiteAdicional={limiteAdicionalVC}
                      />
                      <hr className="h-1" />
                    </>
                  )}
                  {(utilizadoPagueFlex > 0 || disponivelPagueFlex > 0) && (
                    <CreditProgress
                      title="Limite Pague Flex"
                      buttons={true}
                      bottom={false}
                      barra={true}
                      valuePure={setTotalPagueFlexPure}
                      utilizado={utilizadoPagueFlex}
                      disponivel={disponivelPagueFlex}
                      total={totalPagueFlex}
                      setTotal={setTotalPagueFlex}
                      buff={incrementoParametro}
                      input={inputPagueFlex}
                      limiteMaximo={limiteMaximoParametro}
                      limiteAdicional={limiteAdicionalFlex}
                    />
                  )}
                  {trilhaCliente?.codigo && trilhaCliente.codigo == 400 && !!id && (
                    <>
                      <hr className="h-1" />
                      <CreditProgress
                        title="Saldo Vloz"
                        buttons={false}
                        bottom={false}
                        utilizado={utilizadoVloz}
                        disponivel={disponivelVloz}
                        total={totalVloz}
                        setTotal={setTotalVloz}
                        buff={incrementoParametro}
                        input={inputVloz}
                        barra={false}
                        limiteMaximo={limiteMaximoParametro}
                        limiteAdicional={limiteAdicionalVloz}
                      />
                    </>
                  )}
                  {trilhaCliente?.codigo === undefined && cliente.trilha?.codigo == '400' && !!id && (
                    <>
                      {(utilizadoPagueFlex > 0 || disponivelPagueFlex > 0) && (
                          <hr className="h-1" />
                      )}
                      <CreditProgress
                        title="Saldo Vloz"
                        buttons={false}
                        bottom={false}
                        utilizado={utilizadoVloz}
                        disponivel={disponivelVloz}
                        total={totalVloz}
                        setTotal={setTotalVloz}
                        buff={incrementoParametro}
                        input={inputVloz}
                        barra={true}
                        limiteMaximo={limiteMaximoParametro}
                        limiteAdicional={limiteAdicionalVloz}
                      />
                    </>
                  )}
                </ContainerForm>
              )}

            <ContainerForm title="Nova Solicitação">
              <div className="grid gap-x-4 md:grid-cols-1 lg:grid-cols-2">
                <CurrencyInput
                  type="text"
                  value={solicitadoVC}
                  inputName="limiteVotorantim"
                  input={totalVC}
                  setInput={setTotalVC}
                  pure={true}
                  valuePure={setTotalVcPure}
                  labelName={"Limite Votorantim"}

                />
              </div>
              <div className="grid gap-x-4 md:grid-cols-1 lg:grid-cols-2">
                <CurrencyInput
                  type="text"
                  value={solicitadoPagueFlex}
                  inputName="limiteFlex"
                  valuePure={setTotalPagueFlexPure}
                  pure={true}
                  input={totalPagueFlex}
                  setInput={setTotalPagueFlex}
                  labelName={"Limite Pague Flex"}

                />
              </div>

              <div>
                <ul>
                  {solicitadoVC > limiteParametro && (
                      <li>
                        <p className="flex gap-x-2 pt-6">
                          <InfoFormDefault /> *Para limites <strong>Votorantim acima de {money(limiteParametro)}</strong> enviar
                          documentação auxiliar:
                        </p>
                        <p> 1- Balanço + DRE Consolidado (últimos 2 anos). </p>
                        <p> 2- Contrato social com a ultima alteração societária. </p>
                      </li>
                  )}
                  {solicitadoPagueFlex > limiteParametroFlex && (
                      <li>
                        <p className="flex gap-x-2 pt-6">
                          <InfoFormDefault /> *Para limites <strong>Pague Flex acima de {money(limiteParametroFlex)}</strong> enviar
                          documentação auxiliar:
                        </p>
                        <p> 1- Balanço + DRE Consolidado (últimos 2 anos). </p>
                      </li>
                  )}
                </ul>
              </div>

              <div className="flex justify-between mt-6">
                <div>

                  <div>
                <label
                  htmlFor="fileInput"
                  className="
                    cursor-pointer flex items-center gap-x-2 bg-terciaria text-white
                    px-8 py-4 rounded-full font-bold credit-button max-w-[260px]
                  "
                >
                  Upload dos Arquivos
                  <InfoUpload />
                </label>

                    <Input
                        id="fileInput"
                        type="file"
                        name="documentos"
                        style={{ display: "none" }}
                        accept={Object.values(allowedExtensions).join(", ")}
                        multiple

                        onChange={async (event) => {
                          setFieldTouched("documentos", true);
                          const selectedFiles = Array.from(event.target.files);

                          let approvedFiles = [];
                          let errors = [];

                          await Promise.all(
                            selectedFiles.map(async (file) => {
                              const validationResult = await validateFile(file);

                              if (validationResult.success) {
                                approvedFiles.push({ file });
                              } else {
                                errors.push(validationResult.message);
                              }
                            })
                          );

                          let docs = [...approvedFiles];

                          if (Object.entries(documentos).length) {
                            docs.push(...documentos);
                          }

                          setFieldValue("documentos", docs);
                          setDocumentos(docs);

                          setValidationErrorsDoc(errors.length ? errors.join("\n") : "");

                          event.target.value = "";
                        }}
                      />

                  </div>


                  {touched.documentos && errors.documentos && (
                    <p className="text-[14px] text-[#ff0000] mt-2">{errors.documentos}</p>
                  )}

                  {validationErrorsDoc !== undefined && validationErrorsDoc !== "" && (
                    <p className="text-[14px] text-[#ff0000] mt-2">{validationErrorsDoc}</p>
                  )}
                </div>
              </div>
              {!uploadDocAvailable && (
                  <div className="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4" role="alert">
                    <p className="font-bold">Atenção!</p>
                    <p>Um documento já foi anexado nos últimos 30 dias!</p>
                  </div>
              )}

              {documentos &&
                documentos.length > 0 &&
            documentos.map((item, index) => {
                const file = item.file;
                const key = `${file.name}-${file.lastModified}`;

                return (
                  <div className="mt-10" key={key}>
                         <div className="shadow-lg px-4 py-7 rounded-md mb-4">
                      <span className="flex items-center content-between w-[100%]">
                        <span className="flex items-center w-[100%]">
                          {getIconsType(file.type)}
                          <p className="pl-4">{file.name}</p>
                        </span>
                        <span className="w-[10%]">
                          <button
                            type="button"
                            onClick={() => deleteFile(index)}
                            className="px-6 mr-5 py-3 rounded-full bg-quinaria text-white font-bold hover:bg-white hover:text-quinaria border-2 border-quinaria transition duration-300 ease-in-out"
                          >
                            Deletar
                          </button>
                        </span>
                      </span>
                    </div>
                  </div>
                );
              })

              }

              <br />
            </ContainerForm>
          </div>

          {loading && (
              <div className="spinner__form ">
                <Loader />
              </div>
          )}
          <ModalAction
            title={"Atenção!"}
            sub={
              <p>
                Não é possível solicitar um <strong>limite menor</strong> que o atual. Por favor, atualize o valor para continuar.
              </p>
            }
            isOpen={openValidateModal}
            buttonOne="Continuar"
            linkOne={() => {
              handleSubmit(values);
            }}
            buttonTwo="Fechar"
            linkTwo={() => setOpenValidateModal(false)}
            limite={true}
            onClose={() => setOpenValidateModal(false)}
          />

          {showMessageForm.text ? (
            <MessageForm
              text={showMessageForm.text}
              type={showMessageForm.type}
              showMessage={showMessageForm}
              setShowMessage={() =>
                setShowMessageForm({
                  text: "",
                })
              }
              icon={showMessageForm.icon}
            />
          ) : null}

          <ValidateFormModal errors={errors} isSubmiting={isSubmitting} />
        </Form>
      )}
    </Formik>
  );
};

export default Credit;
